/**
 * Display mapping for the `messaged` activity event (SILL-384 T1, t16).
 *
 * The wire payload is `{channel}`-only (`channel ∈ {1on1, broadcast}`, the
 * projector's `messaged` allowlist; `body` is on the never-project denylist).
 * There is NO `medium` field on the wire — the "email" medium is *derived* from
 * the channel for display, because T1 only ever sends 1:1 outreach over email
 * (scenario 44: "channel stays 1on1 while display maps to email"). Keeping the
 * derivation here means the taxonomy (channel) and the presentation (medium)
 * stay decoupled: a future SMS/in-app medium changes only this table.
 */

/**
 * Channel → the medium we surface to the pro. T1 only emits `1on1` → email;
 * SILL-529 added `1on1_sms` → text (the SMS drawer send — keep in lockstep
 * with crm.allowedMessagedChannels).
 */
const CHANNEL_MEDIUM: Record<string, string> = {
  "1on1": "email",
  broadcast: "broadcast",
  "1on1_sms": "text",
};

/**
 * The timeline label for a messaged event, e.g. `"messaged · email"`.
 *
 * Degrades to the bare verb `"messaged"` for an empty or unrecognized channel
 * so a malformed payload never renders `"messaged · undefined"`.
 */
export function messagedDisplayLabel(channel: string): string {
  const medium = CHANNEL_MEDIUM[channel];
  return medium ? `Messaged · ${medium}` : "Messaged";
}
